// SignatureForm.js
import React, { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from '../../lib/constants';
import SignatureCanvas from "react-signature-canvas";
import axios from "axios";
import { useNotification } from '../../contexts/NotificationContext';
import {
  Container,
  Paper,
  Typography,
  Button,
  DialogActions,
} from "@mui/material";

const SignatureForm = () => {
  const { showNotification } = useNotification();
  const { uhid, token } = useParams(); // Make sure route matches this
  const sigRef = useRef(null);
  const [submitted, setSubmitted] = useState(false);

  const handleClear = () => {
    sigRef.current.clear();
  };

  const handleSubmit = async () => {
    const signatureData = sigRef.current.toDataURL().split(",")[1];

    if (!uhid || !token) {
      showNotification('error', "Invalid URL: Missing UHID or token.");
      return;
    }

    try {
      await axios.post(
        `${API_BASE_URL}/remote-signature/${uhid}/${token}`,
        {
          doctor_name_signature: signatureData,
        },
        {
          withCredentials: false, // Only needed if using cookies
        }
      );
      setSubmitted(true);
    } catch (err) {
      console.error("Submission failed:", err);
      showNotification('error', "Failed to submit signature.");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={4} sx={{ p: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          ✍️ Doctor Signature
        </Typography>

        {submitted ? (
          <Typography variant="h6" align="center" color="success.main">
            ✅ Signature submitted successfully!
          </Typography>
        ) : (
          <>
            <SignatureCanvas
              ref={sigRef}
              canvasProps={{
                width: 400,
                height: 200,
                className: "sigCanvas",
              }}
              backgroundColor="#f0f0f0"
            />
            <DialogActions sx={{ mt: 2 }}>
              <Button onClick={handleClear} color="secondary" variant="outlined">
                Clear
              </Button>
              <Button onClick={handleSubmit} color="primary" variant="contained">
                Submit
              </Button>
            </DialogActions>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default SignatureForm;
